import {
  AppRegistration,
  AutoFixHigh,
  CropOriginal,
  DriveFolderUpload,
  KeyboardArrowDown,
} from '@mui/icons-material';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState, type MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItemLink } from '~/components/link';

export interface ContentAddButtonProps {
  canDesign: boolean;
  canUpload: boolean;
  /** Receives the Add button, so the upload dialog can hand focus back to it on close. */
  onUpload: (returnFocus: HTMLElement | null) => void;
}

export const ContentAddButton = ({ canDesign, canUpload, onUpload }: ContentAddButtonProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        color="primary"
        endIcon={<KeyboardArrowDown />}
        onClick={handleClick}
        startIcon={<CropOriginal />}
        variant="contained"
      >
        {t('pages.content.dialogs.add_content_menu.add_content')}
      </Button>
      <Menu anchorEl={anchorEl} onClose={handleClose} open={open}>
        <MenuItem
          disabled={!canUpload}
          onClick={() => {
            onUpload(anchorEl);
            handleClose();
          }}
        >
          <ListItemIcon>
            <DriveFolderUpload />
          </ListItemIcon>
          <ListItemText>{t('pages.content.dialogs.add_content_menu.upload_media')}</ListItemText>
        </MenuItem>
        <MenuItemLink disabled={!canDesign} to="../../studio">
          <ListItemIcon>
            <AutoFixHigh />
          </ListItemIcon>
          <ListItemText>{t('pages.content.dialogs.add_content_menu.new_design')}</ListItemText>
        </MenuItemLink>
        <MenuItemLink to="../../templates">
          <ListItemIcon>
            <AppRegistration />
          </ListItemIcon>
          <ListItemText>
            {t('pages.content.dialogs.add_content_menu.browse_templates')}
          </ListItemText>
        </MenuItemLink>
      </Menu>
    </>
  );
};
